export type TabStore = Record<
  string,
  {
    tabs: string[][];
    current_tabs: string[];
  }
>;

export const initTabsStore = () => {
  window.Alpine.store("tabs", {});

  const tabs = window.Alpine.store("tabs") as TabStore;
  window.Alpine.magic("tabs", () => tabs);
  window._stores["tabs"] = tabs;
};

export const initTabs = ($el: HTMLElement) => {
  const raw_tabs = utils.JSONParse<string[]>($el.getAttribute("data-tabs") ?? "[]");

  const tabs = window.Alpine.store("tabs") as TabStore;

  tabs[$el.id] = {
    tabs: raw_tabs?.map((t) => t?.split("|%S%|")),
    current_tabs: raw_tabs?.map((t) => t?.split("|%S%|")?.[0] ?? ""),
  };

  const ensureNoHiddenTabs = async () => {
    for (let i = 0; i < tabs[$el.id].current_tabs.length; i++) {
      const nodes = [...$el.querySelectorAll(`[data-tab-group="${i}"][data-tab-id]`)] as HTMLElement[];

      if (!nodes.length) return;

      const currentId = tabs[$el.id].current_tabs?.[i];
      const currentEl = nodes.find((el) => el.getAttribute("data-tab-id") === currentId);
      const isCurrentVisible = currentEl ? utils.isVisible(currentEl) : false;

      if (isCurrentVisible) return;

      for (const node of nodes) {
        if (node === currentEl) continue;
        tabs[$el.id].current_tabs[i] = node?.getAttribute("data-tab-id");
        let break_loop = false;

        await new Promise((resolve) => {
          window.requestAnimationFrame(() => {
            if (utils.isVisible(node)) {
              break_loop = true;
            }
            resolve(true);
          });
        });
        if (break_loop) {
          break;
        }
      }
    }
  };

  ensureNoHiddenTabs();
  const resizeObserver = new ResizeObserver(() => ensureNoHiddenTabs());
  resizeObserver.observe(document.documentElement);
  window.addEventListener("orientationchange", () => ensureNoHiddenTabs());

  return tabs[$el.id];
};

export type InitTabs = typeof initTabs;

window._sections["initTabs"] = initTabs;
